export enum CustomErrorType {
    IndexTimeout = 'IndexTimeout',
    ZoneRestrictions = 'ZoneRestrictions',
    InvalidLatLngFormat = 'InvalidLatLngFormat',
    BatchFailed = 'BatchFailed'
}
